import generateRender from 'shared/utils/generateRender';
import DefaultPurchaseHeader from '../../../../../../components/JSModal/components/DefaultHeader';

const RespopnseHeader = generateRender({
  default: DefaultPurchaseHeader,
});

export default RespopnseHeader;

